var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#FF8932",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21064 8.01106C3.1254 7.60191 3.54993 7.27496 3.92373 7.46187L6.84208 8.92104C6.9323 8.96615 7.04199 8.93702 7.09794 8.8531L9.58397 5.12404C9.78189 4.82717 10.2181 4.82717 10.416 5.12404L12.9021 8.8531C12.958 8.93702 13.0677 8.96615 13.1579 8.92104L16.0763 7.46187C16.4501 7.27496 16.8746 7.60191 16.7894 8.01106L15.4163 14.602C15.368 14.8338 15.1636 15 14.9268 15H5.07324C4.8364 15 4.63205 14.8338 4.58375 14.602L3.21064 8.01106Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default ForwardRef;